
import { Component, Vue } from "vue-property-decorator";
import PartRequestStoreError from './error/PartRequestStoreError.vue';

@Component({
  components: {PartRequestStoreError},
})
export default class PartRequestIndex extends Vue {}
